// extracted by mini-css-extract-plugin
module.exports = {"menuDropdown":"NavBrand_menuDropdown__YMb8A","menuItemDropdown":"NavBrand_menuItemDropdown__2mhxX","brand":"NavBrand_brand__2E2VH"};